import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import NotFound from "./SharedComponents/NotFound";
import AppIndex from "./App/AppIndex";
import Login from "./App/Login";
import Signup from "./App/Signup";
import ResetPassword from "./App/ResetPassword";
import NewPassword from "./App/NewPassword"; 
import SignupVerification from "./App/SignUpVerification";
import AuthPortal from "./App/AuthPortal";
import UpdateProfile from "./App/UpdateProfile";
import Faqs from "./App/Faqs";
import Pricing from "./App/Pricing";
import Landing from "./App/Landing";
import CheckoutSuccess from "./App/CheckoutSuccess";
import AboutUs from "./App/AboutUs";
import Resources from "./App/Resources";
import TermsConditions from "./App/TermsConditions";
import PrivacyPolicy from "./App/PrivacyPolicy";
import Newsletter from "./App/Newsletter";
import ContactUs from "./App/ContactUs";
import ScrapePortal from "./App/ScrapePortal";
import DataProcessing from "./App/DataProcessing";
import SubProcessorList from "./App/SubProcessorList";
import PrivateChatbot from "./App/PrivateChatbot";
import SearchFunction from "./App/SearchFunction";
import TestDesign from "./App/AppIndexUpdate";
import PrivateDemo from "./App/PrivateDemo";
import GatewayPortal from "./App/Gateway";
import OurProducts from "./App/Products";
import NewLanding from "./App/NewLanding";
import AiConsulting from "./App/AiConsulting";
import CustomSolutions from "./App/CustomSolutions";
import TransferExample from "./App/TransferExample";
import ProfileSection from './App/NewProfilesection/ProfileSection';
import MyProduct from './App/NewProfilesection/MyProduct';
import Shop from './App/NewProfilesection/Shop';
import Support from './App/NewProfilesection/Support';
import TrainingPage from './App/NewProfilesection/TrainingPage';
import ActivityLog from './App/NewProfilesection/ActivityLog';
// import PrivatESRA_UI from './App/PrivateTesting';
import PrivatESRAResponsive from './App/PrivateTesting';
import AppCanvas from './App/Canvass';
import Plateform from './App/Plateform';
import EsraProduct from './App/EsraProduct';
import Enterprise from './App/Enterprise';
import ResearchLab from './App/ResearchLab';
import Ml from './App/Ml';
import NewTraining from './App/NewTraining';
import SmartEIA from './App/SmartEia/SmartEIA';
import Success from './App/Success';
import NotionTemplates from './App/NotionTemplates/NotionTemplates';
import VentureLayout from './App/NewVenture/Venture/VentureLayout';
import Dashboard from './App/NewVenture/Venture/Pages/Dashboard';
import VentureLogin from './App/NewVenture/Venture/VentureLogin';
import FeedbackForm from './App/NewVenture/Venture/Pages/FeedbackForm';


export default ({ childProps }) => {
    return (

        <Router>

            
<Switch>
            <Route exact path="/chat" component={AppIndex} />
            <Route exact path="/testing" render={(props) => <AppIndex {...props} showSidebarOnLoad={true} />} />
            <Route exact path="/chatgpt-prompt" render={(props) => <AppIndex {...props} chatgptPromptType={true} />} />
            <Route exact path="/category-prompt" render={(props) => <AppIndex {...props} categoryPromptType={true} />} />
            <Route exact path="/individual-prompt" render={(props) => <AppIndex {...props} individualPromptType={true} />} />
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route path="/auth" component={AuthPortal} />
            <Route path="/signup-verification" component={SignupVerification} />
            {/* <Route path="/profile" component={UpdateProfile} /> */}
            <Route path="/profile" component={ProfileSection} />
            <Route path="/ventureLogin" component={VentureLogin} />
            <Route path="/venture" component={VentureLayout} />
            <Route path="/feedback-form" component={FeedbackForm} />
            <Route path="/myproduct" component={MyProduct} />
            <Route path="/shops" component={Shop} />
            <Route path="/support" component={Support} />
            <Route path="/training" component={TrainingPage} />
            <Route path="/activity" component={ActivityLog} />
            <Route path="/faqs" component={Faqs} />
            <Route exact path="/success" component={Success} />
            <Route path="/admin" component={SearchFunction} />
            <Route path="/about-us" component={AboutUs} />
            <Route path="/resources" component={Resources} />
            <Route path="/transfer-example" component={TransferExample} />
            <Route path="/terms-policies" component={TermsConditions} />
            <Route path="/trainings" component={NewTraining} />
            <Route path="/smarteia" component={SmartEIA} />
            <Route path="/data-processing" component={DataProcessing} />
            <Route path="/sub-processor-list" component={SubProcessorList} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route path="/pricing" component={Pricing} />
            <Route path="/enterprise-builds" component={Enterprise} />
            <Route path="/research-lab" component={ResearchLab} />
            <Route path="/ml" component={Ml} />
            <Route path="/newlanding" component={NewLanding} />
            <Route path="/private" component={PrivateChatbot} />
            {/* <Route path="/portal" component={GatewayPortal} /> */}
            {/* <Route path="/privatesra" component={PrivateDemo} /> */}
            <Route path="/privatesra" component={PrivatESRAResponsive} />
            <Route path="/plateform" component={Plateform} />
            <Route path="/esraproduct" component={EsraProduct} />
            <Route path="/our-products" component={OurProducts} />
            <Route path="/ai-consulting" component={AiConsulting} />
            <Route path="/custom-solutions" component={CustomSolutions} />
            <Route path="/newsletter" component={Newsletter} />
            <Route path="/contact-us" component={ContactUs} />
            <Route path="/design-update" component={TestDesign} />
            <Route path="/notion" component={NotionTemplates} />
            <Route path="/checkout-success" component={CheckoutSuccess} />
            <Route
  exact
  path="/"
  component={NewLanding}
/>
            
            
            <Route component={NotFound}/>
        </Switch>

        </Router>
        
    );
};
    


